// styling
import styles from './styles.module.scss';

// components
import Spring from '@components/Spring';
import {NavLink} from 'react-router-dom';

// hooks
import {useThemeProvider} from '@contexts/themeContext';

// utils
import classNames from 'classnames';

// assets
import dark404 from '@assets/404dark.webp';
import light404 from '@assets/404light.webp';

const Error404 = () => {
    const {theme} = useThemeProvider();

    return (
        <Spring className={`${styles.container} card d-flex align-items-center flex-1`}>
            <div className={styles.media}>
                <img className={classNames(styles.media_img, {[styles.visible]: theme === 'light'})}
                     src={light404}
                     alt="404"/>
                <img className={classNames(`${styles.media_img} ${styles.dark}`, {[styles.visible]: theme === 'dark'})}
                     src={dark404}
                     alt="404"/>
            </div>
            <div className={styles.main}>
                <h2 className={styles.main_title}>
                    Oops! <span>La página que esta buscando no existe.</span>
                </h2>
                <p className={styles.main_text}>
                    Por favor, confirma la URL e intenta nuevamente.
                </p>
                <NavLink className="btn" to="/">Ir al inicio</NavLink>
            </div>
        </Spring>
    )
}

export default Error404